import { render, staticRenderFns } from "./AppResTop.vue?vue&type=template&id=2c03c216&scoped=true&"
import script from "./AppResTop.vue?vue&type=script&lang=js&"
export * from "./AppResTop.vue?vue&type=script&lang=js&"
import style0 from "./AppResTop.vue?vue&type=style&index=0&id=2c03c216&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c03c216",
  null
  
)

export default component.exports